import * as TypeGraphQL from "type-graphql";
export var EventCategory;
(function (EventCategory) {
    EventCategory["TRADE"] = "TRADE";
    EventCategory["SIGNAL"] = "SIGNAL";
    EventCategory["ALERT"] = "ALERT";
    EventCategory["RISK_BREACH"] = "RISK_BREACH";
    EventCategory["SYSTEM"] = "SYSTEM";
    EventCategory["COMPLIANCE"] = "COMPLIANCE";
    EventCategory["EXECUTION"] = "EXECUTION";
    EventCategory["SYNC"] = "SYNC";
})(EventCategory || (EventCategory = {}));
TypeGraphQL.registerEnumType(EventCategory, {
    name: "EventCategory",
    description: undefined,
});
//# sourceMappingURL=EventCategory.js.map